<template>
  <el-dialog title="查看杂费明细" width="600px" class="import-statement-dialog" v-model="dialog.show" :before-close="closeDialog" append-to-body :close-on-click-modal='false'>
    <div>
      <ab-table
        border
        showOrder
        index-label="序号"
        indexWidth="50"
        maxHeight="226"
        :column-list="columns"
        :table-list="tableData"
        :dataListLoading="tableLoading">
      </ab-table>
      
    </div>
    <template #footer>
        <div class="sum">合计：￥{{$filters.formatMoney(sumAmount)}} </div>
        <div  class="dialog-footer">
            <el-button @click="closeDialog">取 消</el-button>
        </div>
    </template>
  </el-dialog>
</template>

<script>

export default {
  name: 'import-statement-dialog',
 
  props: {
    dialog: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      tableLoading: false,
      columns: [
        {
          labels: '计费项目',
          props: 'expenseItemName',
          widths: 100
        },
        {
          labels: '金额',
          props: 'arAmount',
          widths: 100,
          type: 'money',
          align: 'right'
        },
        {
          labels: '备注',
          props: 'remark',
          widths: 140
        },
        {
          labels: '应付日期',
          props: 'arDate',
          widths: 100
        }
      ],
      tableData: []
    }
  },
  watch: {
    dialog: {
      handler: function (val, oldval) {
        this.queryOtherFeeList()
      },
      deep: true
    }
  },
  computed: {
    sumAmount () {
      return this.tableData.map(row => row.arAmount).reduce((acc, cur) => {
        if (!cur) {
          cur = 0
        }
        return this.$calc.add(cur, acc)
      }, 0)
    }
  },
  mounted () {
    
  },
  methods: {
    queryOtherFeeList () {
      if (Object.keys(this.dialog.data).length) {
        let params = {
          customsId: this.dialog.data.customsId,
          coreBillId: this.dialog.data.coreBillId,
          isCurrentAdjustItem: this.dialog.data.isCurrentAdjustItem,
          parentId: this.dialog.data.parentId
        }
        let bizTypes = this.$utils.getSessionStorage('bizType') || {}
        let url = '/sms/importAccounts/queryOtherFeeList'
        if (bizTypes.activeIndex == '02') {
           url = '/sms/exportAccounts/queryOtherFeeList'
        } 
        this.$post(url, { data: params }, this, 'tableLoading').then(({ data }) => {
          if (data && data.code === 'C0000') {
            let result = data.result || []
            result.forEach(row => {
              row.arDate = row.arDate ? this.$utils.getDate(row.arDate) : ''
            })
            this.tableData = result
          } else {
            this.tableData = []
          }
        })
      } else {
        this.tableData = []
      }
    },

    closeDialog () {
      this.dialog.show = false
      this.dialog.data = {}
    }
  }
}
</script>

<style lang="scss">
.import-statement-dialog {
  .el-dialog__footer {
    position: relative;
  }
  .el-table {
    margin-bottom: 0!important;
  }
  .sum {
    position: absolute;
    top: -30px;
    left: 0;
    width: 400px;
    height: 42px;
    padding-left: 20px;
    font-size: 16px;
    font-weight: bold;
    line-height: 42px;
    text-align: left;
    color: #FA7F14;
  }
}
</style>
